import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Table property - Definition */
export class DocsBlockTablePropertyDefinition extends DocsBlockPropertyDefinition {
}
